import { StudentInStudentList } from "../store/types"

export const getCommonStartgoal = (
  members: StudentInStudentList[]
): string | undefined => {
  const hasSameStartGoal = members.every(m => m.goalRef === members[0].goalRef)
  return hasSameStartGoal ? members[0].goalRef : undefined
}
